import { CSS_SELECTOR, useCustomCss } from '../../contexts/CustomCss';
import { Color, getHighContrastTextColor } from '../../styles';
import { FunctionalComponent, RefObject, h } from 'preact';
import Button from './Button.styles';
import { memo } from 'preact/compat';
import { useTheme } from 'styled-components';

export interface ButtonComponentProps {
  ariaLabel?: string;
  backgroundColor: Color;
  buttonRef?: RefObject<HTMLButtonElement>;
  disabled?: boolean;
  fullWidth?: boolean;
  label?: string;
  onClick?: () => void;
  testid: string;
  textColor?: Color;
}

const ButtonComponent: FunctionalComponent<ButtonComponentProps> = memo(
  ({
    ariaLabel = '',
    backgroundColor,
    buttonRef,
    disabled = false,
    fullWidth = true,
    label,
    onClick,
    testid,
    textColor,
  }) => {
    const theme = useTheme();
    const { rules } = useCustomCss(CSS_SELECTOR.BUTTONS);

    return (
      <Button
        {...(ariaLabel && ariaLabel !== '' && { 'aria-label': ariaLabel })}
        role="button"
        backgroundColor={backgroundColor}
        disabled={disabled}
        data-testid={testid}
        fullWidth={fullWidth}
        onClick={onClick}
        ref={buttonRef}
        textColor={textColor?.default || getHighContrastTextColor(backgroundColor.default, theme.typography.color)}
        style={{ ...rules }}
      >
        {label}
      </Button>
    );
  },
);

export default ButtonComponent;
